import { LoansSignLoanDocumentData } from '@servicetitan/financing-api-client';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface SignatureData {
    applicantSignature: string;
    coApplicantSignature: string;
    skipSignatureButtonClicked: boolean;
    signDocumentResult: LoansSignLoanDocumentData;
    signedSuccessfully: boolean;
    loanDocumentLoaded: boolean;
}

function useSignatureDataStore(
    initialState: SignatureData = {
        applicantSignature: '',
        coApplicantSignature: '',
        skipSignatureButtonClicked: false,
        signDocumentResult: null,
        signedSuccessfully: false,
        loanDocumentLoaded: false,
    },
) {
    const [signatureData, setSignatureData] = useState(initialState);
    return { signatureData, setSignatureData };
}

export const SignatureDataStore = createStore(useSignatureDataStore);
